/**
 * 不同地区的差异性配置
 * 1、districtLanguage 国家地区的语言列表
 * 2、currentDistrict 当前所在的国家地区
 * 3、languages 当前国家地区的语言列表，默认认为第一项为默认语言
 */

/**
 * {{ $t('w1152') }}，{{ $t('w1153') }}
 */
export const districtLanguage = {
    China: ['zh_CN', 'en_US'],
    Thailand: ['th_TH', 'en_US', 'zh_CN']
  }
  
  /**
   * 获取当前地区
   */
  export const currentDistrict =  process.env.VUE_APP_DISTRICT
  
  /**
   * 获取当前地区语言
   */
  export const languages = districtLanguage[currentDistrict]